<div class="title warning">{{title}}</div>
<div class="message">{{message}}</div>
